import {
  mdiDomain,
  mdiMapMarkerOutline,
  mdiAccountTieOutline,
  mdiBankOutline,
} from "@mdi/js";

export const BUSINESS_TYPE_LABEL: Record<string, string> = {
  tire_service: "Шиномонтаж",
  car_wash: "Автомойка",
};

export const TRANSACTION_TYPE_LABEL: Record<string, string> = {
  payment: "Оплата",
  payout: "Выплата",
  refund: "Возврат",
};

export const TRANSACTION_TYPE_COLOR: Record<
  string,
  "success" | "warning" | "danger" | "default"
> = {
  payment: "success",
  payout: "warning",
  refund: "danger",
};

export const TRANSACTION_STATUS_LABEL: Record<string, string> = {
  success: "Проведён",
  pending: "Ожидание",
  pending_confirmation: "Ожидание подтверждения",
  processing: "Обработка",
  failed: "Ошибка",
  refunded: "Возвращён",
  partially_refunded: "Частичный возврат",
  cancelled: "Отменён",
};

export const TRANSACTION_STATUS_COLOR: Record<
  string,
  "success" | "warning" | "danger" | "default"
> = {
  success: "success",
  pending: "warning",
  pending_confirmation: "warning",
  processing: "warning",
  failed: "danger",
  refunded: "danger",
  partially_refunded: "danger",
  cancelled: "danger",
};

export const PAYMENT_METHOD_LABEL: Record<string, string> = {
  card: "Карта",
  sbp: "СБП",
  sbp_tbank: "СБП (Т-Банк)",
  cash: "Наличные",
  bank_transfer: "Банковский перевод",
  acquiring: "Эквайринг",
  tbank: "Т-Банк",
  tinkoff: "Тинькофф",
  online: "Онлайн",
};

export const BOOKING_STATUS_LABEL: Record<string, string> = {
  pending: "Создан",
  pending_confirmation: "Ожидание подтверждения",
  confirmed: "Подтверждено",
  in_progress: "В работе",
  completed: "Завершено",
  cancelled: "Отменено",
  no_show: "Не явился",
};

export const BOOKING_STATUS_COLOR: Record<
  string,
  "warning" | "accent" | "success" | "danger" | "default"
> = {
  pending: "warning",
  pending_confirmation: "warning",
  confirmed: "accent",
  in_progress: "accent",
  completed: "success",
  cancelled: "danger",
  no_show: "danger",
};

export const PAYMENT_STATUS_LABEL: Record<string, string> = {
  pending: "Ожидание",
  paid: "Оплачено",
  refunded: "Возврат",
  partially_refunded: "Частичный возврат",
};

export const PAYMENT_STATUS_COLOR: Record<
  string,
  "warning" | "success" | "danger"
> = {
  pending: "warning",
  paid: "success",
  refunded: "danger",
  partially_refunded: "danger",
};

export const PAYOUT_STATUS_LABEL: Record<string, string> = {
  success: "Выплачено",
  processing: "Обработка",
  pending: "Ожидание",
  failed: "Ошибка",
};

export const PAYOUT_STATUS_COLOR: Record<
  string,
  "success" | "accent" | "warning" | "danger"
> = {
  success: "success",
  processing: "accent",
  pending: "warning",
  failed: "danger",
};

export const MONTHS_SHORT = [
  "Янв",
  "Фев",
  "Мар",
  "Апр",
  "Май",
  "Июн",
  "Июл",
  "Авг",
  "Сен",
  "Окт",
  "Ноя",
  "Дек",
];

export const PASS_KEYS = [
  "Backspace",
  "Delete",
  "ArrowLeft",
  "ArrowRight",
  "ArrowUp",
  "ArrowDown",
  "Tab",
  "Enter",
  "Home",
  "End",
];
export const COUNTRY_LABELS: Record<string, string> = {
  RUS: "Россия",
  BLR: "Беларусь",
  KAZ: "Казахстан",
  UZB: "Узбекистан",
  KGZ: "Кыргызстан",
  ARM: "Армения",
  TJK: "Таджикистан",
};
export const LEGAL_STEPS = [
  { id: 1, label: "Реквизиты", icon: mdiDomain },
  { id: 2, label: "Юр. Адрес", icon: mdiMapMarkerOutline },
  { id: 3, label: "Руководитель", icon: mdiAccountTieOutline },
  { id: 4, label: "Банк", icon: mdiBankOutline },
] as const;

export const numericOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (PASS_KEYS.includes(e.key)) return;
  if (!/^\d$/.test(e.key)) e.preventDefault();
};

export const latinOnly = (e: React.KeyboardEvent<HTMLInputElement>) => {
  if (e.ctrlKey || e.metaKey || e.altKey) return;
  if (PASS_KEYS.includes(e.key)) return;
  if (!/^[A-Za-z0-9 .\-*]$/.test(e.key)) e.preventDefault();
};

/**
 * Применяет маску +7XXXXXXXXXX (11 цифр слитно).
 * Ввод нормализуется: 8→7, добавляется 7 если первая не 7.
 */
export const applyPhoneMask = (raw: string): string => {
  const digits = raw.replace(/\D/g, "");
  let d = digits;
  if (d.startsWith("8")) d = "7" + d.slice(1);
  else if (!d.startsWith("7") && d.length > 0) d = "7" + d;
  const n = d.slice(0, 11); // макс 11 цифр (7 + 10)
  if (n.length === 0) return "";
  return `+${n}`;
};

/** Конвертирует маскированный телефон обратно в +xxxxxxxxxxx */
export const phoneMaskToRaw = (masked: string): string => {
  const digits = masked.replace(/\D/g, "");
  if (!digits) return "";
  return `+${digits}`;
};
